import { qs, qsa } from "@fluorescent/dom";
import {
  ImageReveal,
  FadeUpReveal,
  FadeUpSplitReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  image: ".image-with-features__image-container .image",
  title: ".image-with-features__heading",
  featuresItem: ".image-with-features__item",
  fadeUp: ".animation-fade-up-reveal",
  fadeUpSplit: ".animation-fade-up-split-reveal",
};

export default node => {
  let observer = null;
  const sectionTitle = qs(selectors.title, node);
  const featureItems = qsa(selectors.featuresItem, node);
  const image = qs(selectors.image, node);

  const featureItemReveals = [];
  let imageReveal = null;

  if (shouldAnimate(node)) {
    // Initialize animations and intersection observer
    featureItemReveals.push(new FadeUpSplitReveal(sectionTitle));

    featureItems.forEach(item => {
      featureItemReveals.push(
        new FadeUpSplitReveal(qs(selectors.fadeUpSplit, item))
      );
      qsa(selectors.fadeUp, item).forEach(fadeItem => {
        featureItemReveals.push(new FadeUpReveal(fadeItem));
      });
    });

    if (image) {
      imageReveal = new ImageReveal(image);
    }

    observer = intersectionWatcher(node, { cb: isVisible });
  }

  function isVisible() {
    let featureItemDelay = window.theme.animation.delay;
    featureItemReveals.forEach(featureItem => {
      featureItem.play(featureItemDelay);

      if (featureItem.type === "FadeUpSplitReveal") {
        featureItemDelay +=
          featureItem.lineCount * window.theme.animation.delay;
      } else {
        featureItemDelay += window.theme.animation.delay;
      }
    });

    if (imageReveal) {
      imageReveal.play(window.theme.animation.delay);
    }
  }

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
